import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportSites = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (fileName: string) =>
      await request(`${sport}/o/${organizationId}/sites/import`, {
        method: "POST",
        body: { fileName },
      }),
  });
};
